// extracted by mini-css-extract-plugin
export default {"tag":"_tag_tag__ZCar8","light":"_tag_light__QoIZZ","dark":"_tag_dark__0tuNI","button":"_tag_button__NK6Pc"};